import React from 'react'
import { TextField, MenuItem, useTheme, TextFieldProps } from '@mui/material'
import { useField, useFormikContext } from 'formik'

interface SelectOption {
  value: string | number
  label: string
}

export type FormSelectFieldProps = Omit<TextFieldProps, 'name' | 'select' | 'onChange'> & {
  name: string
  label: string
  options?: SelectOption[]
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const FormSelectField: React.FC<FormSelectFieldProps> = ({
  name,
  label,
  options = [],
  ...props
}) => {
  const theme = useTheme()
  const [field, meta] = useField(name)
  const { setFieldValue } = useFormikContext()

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    setFieldValue(name, evt.target.value)
    if (props.onChange) props.onChange(evt)
  }

  return (
    <TextField
      {...field}
      {...props}
      select
      fullWidth
      label={label}
      variant="outlined"
      margin="dense"
      onChange={handleChange}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error}
      slotProps={{
        input: {
          sx: { borderRadius: theme.appRadius?.sm || '6px' }
        }
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default FormSelectField
